const store = require('@/store').default
const eb = require('@/services/eventBus')
const customLogger = require('@/utils').customLogger

function init() {
    var jobs = JSON.parse(localStorage.getItem('active_job')) || {}

    for (var key in jobs) {
        for (var i = 0; i < jobs[key].length; i++) {
            if (jobs[key][i]) {
                const now = Date.now()

                if (now > jobs[key][i].time)
                    run_job(key, i, 0)
                else
                    run_job(key, i, jobs[key][i].time - now)
            }
        }
    }
}

function create(id, sec, cb, ...args) {
    var jobs = JSON.parse(localStorage.getItem('active_job')) || {}

    if (jobs[id] == null)
        jobs[id] = []
    const idx_job = jobs[id].push({
        time: Date.now() + sec * 1000,
        cb: cb.toString(),
        args: {...args}
    }) - 1

    localStorage.setItem('active_job', JSON.stringify(jobs))
    run_job(id, idx_job, sec * 1000)
}

function run_job(key, i, time) {
    setTimeout(() => {
        var jobs = JSON.parse(localStorage.getItem('active_job')) || {}

        // customLogger("set time out ", jobs, id, idx_job)
        eval( '(' + jobs[key][i].cb + ')').call({eb, store, ...jobs[key][i].args})
        delete jobs[key][i]
        localStorage.setItem('active_job', JSON.stringify(jobs))
    }, time)
}

module.exports = {
  init,
  create
};
